module.exports = __webpack_public_path__ + "static/img/02.92d1574f.jpg";